import { calculateAppEnvironment } from '@wix/error-monitor'
import { tryCatchSync } from '@wix/funnel-utils'
import { createGlobalConfig, panoramaClientFactory, PanoramaPlatform } from '@wix/panorama-client-web'

export const globalConfig = createGlobalConfig()

const panoramaFactory = panoramaClientFactory({
  baseParams: {
    platform: PanoramaPlatform.Standalone,
    fullArtifactId: 'com.wixpress.funnel-intro-viewer',
    artifactVersion: window.__ARTIFACT_VERSION__,
    componentId: 'funnel-intro-viewer',
    uuid: window.__USER_ID__,
  },
  pluginParams: {
    sentry: window.Sentry,
    sentryDsn: window.__SENTRY_DSN__,
    sentryMain: true,
    sentryEnvironment: calculateAppEnvironment(),
  },
}).withGlobalConfig(globalConfig)

export const panoramaClient = panoramaFactory.client()

type FlushableBatchQueue = { queue?: unknown[]; flush?: () => void }

// Flush the pending batch before navigation, using the same queue hook as Chat/Wildcat.
export const flushPanorama = () => {
  tryCatchSync(() => {
    const batchQueue = globalConfig.getBatchQueue() as unknown as FlushableBatchQueue | null
    if (Array.isArray(batchQueue?.queue) && batchQueue.queue.length === 0) {
      return
    }
    batchQueue?.flush?.()
  })
}

window.addEventListener('pagehide', flushPanorama)
window.addEventListener('beforeunload', flushPanorama)
